module.exports = __webpack_public_path__ + "static/media/fourteenth_the_inn6.8d04ab95.png";